import React, { useEffect, useState } from "react";
import {
  fetchAllLanguages,
  fetchAllTranslationsForLanguage,
} from "../utils/dbutils";
import { initPageTranslations } from "../utils/Utils";
import "react-data-grid/lib/styles.css";
import ReactDataGrid from "react-data-grid";

function Translation() {
  const phrases = ["Language", "New Language"];
  const [translations, setTranslations] = useState(null);
  const [languages, setLanguages] = useState([]);
  const [language, setLanguage] = useState("vie");
  const [, forceUpdate] = useState(0); // Used to force re-render

  const [rows, setRows] = useState(null);
  const columns = [
    { key: "page", name: "Page", sortable: true },
    { key: "original", name: "Original", editable: true, sortable: true },
    { key: "translation", name: "Translation", editable: true },
  ];
  const xrows = [
    { page: "SignIn", original: "Example", translation: "Vi du" },
    { page: "SignIn", original: "Demo", translation: "Thu nghiem" },
  ];

  const onGridRowsUpdated = ({fromRow, toRow, updated}) => {
    const rws = rows.slice();
    for (let i = fromRow; i <= toRow; i++) {
      rws[i] = { ...rws[i], ...updated };
    }
    setRows(rws);
  };

  const onlanguagechange = () => (e) => {
    const lang = e.target.value;
    setLanguage(lang);
    localStorage.setItem("language", lang);
    setLanguage(lang);
    getAllPhrasesForLanguage(lang);
  };

  const getAllPhrasesForLanguage = async (lang) => {
    const phrs = await fetchAllTranslationsForLanguage(lang);
    var rws = [];
    for (var phr of phrs) {
      for (var phrase of Object.keys(phr.phrases)) {
        rws.push({
          page: phr.page,
          original: phrase,
          translation: phr.phrases[phrase],
        });
      }
    }
    setRows(rws);
    forceUpdate((n) => !n);
  };

  const doInit = async () => {
    const langs = await fetchAllLanguages();
    setLanguages(langs);
    initTranslations();
    const lang = localStorage.getItem("language") || "vie";
    setLanguage(lang);
    getAllPhrasesForLanguage(lang);
  };

  const initTranslations = async () => {
    const tr = await initPageTranslations(phrases, "Translation");
    setTranslations(tr);
  };

  useEffect(() => {
    doInit();
  }, []);

  if (!translations || !rows) {
    return <></>;
  }

  return (
    <>
      <div className="flex-col h-[92vh]">
        <div className="flex mt-20"></div>
        <div className="flex gap-2">
          <label htmlFor="language" className="text-md text-base-content m-1">
            {translations["Language"]}
          </label>
          <div className="">
            <select
              id="language"
              name="language"
              autoComplete="language"
              value={language}
              onChange={onlanguagechange()}
              className="text-base-content border border-base-content rounded-none p-1 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            >
              {languages.map((lang, i) => (
                <option key={i}>{lang}</option>
              ))}
            </select>
          </div>
          <button className="btn btn-sm rounded-none">
            {translations["New Language"]}
          </button>
        </div>

        <div className="">
          <ReactDataGrid
            columns={columns}
            rows={rows}
            rowGetter={(i) => rows[i]}
            rowsCount={rows.length}
            onRowsUpdate={onGridRowsUpdated}
            // onGridRowsUpdated={onGridRowsUpdated}
            enableCellSelect={true}
          />
        </div>
      </div>
    </>
  );
}

export default Translation;
